import { useQuery } from '@tanstack/react-query';
import { GET_SOURCES_DAILY_STATS_FOR_DOMAIN } from '../../../../query/monitor/data/sources/keys';
import {
  getSourcesDailyStatsForDomain,
  SourcesDailyStatsResponse,
} from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';
import { MonitorPeriod } from '../../../../../types/monitor/MonitorPeriod';

export const useGetSourcesDailyStatsForDomain = (
  projectId: number | null,
  domain: string,
  chatType: ChatType | null,
  period: MonitorPeriod | null,
  from: Date | null,
  to: Date | null,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryEnabled = !!projectId && !!domain && !!chatType && !!period && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const {
    data: sourcesDailyStats,
    isLoading,
    isError,
    error,
  } = useQuery<SourcesDailyStatsResponse>({
    queryKey: [GET_SOURCES_DAILY_STATS_FOR_DOMAIN, projectId, domain, chatType, period, fromTimestamp, toTimestamp, monitorPromptIds, filterMonitorTypes],
    queryFn: () => getSourcesDailyStatsForDomain(projectId!, domain, chatType!, period!, from, to, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    sourcesDailyStats: queryEnabled ? sourcesDailyStats : undefined,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
  };
};
